export { default } from './SparklineChart.js';
